module.exports = __webpack_public_path__ + "static/q3answer3_apartment_wishmas-e1266a2602277462d4a29282549307e5.jpg";